import { render } from "./Loading.vue?vue&type=template&id=d4efa38a&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=d4efa38a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d4efa38a"

export default script